import Swal from "sweetalert2";

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", async (e) => {
    const link = e.target.closest(".change-status-link");
    if (!link) return;

    e.preventDefault();

    const url = link.dataset.url;
    const method = link.dataset.method || "PATCH";
    const confirmMsg = link.dataset.confirm || "Are you sure?";
    const deliveryId = link.dataset.deliveryId;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    const result = await Swal.fire({
      title: "Confirm Action",
      text: confirmMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Processing...",
      text: "Updating status...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const response = await fetch(url, {
        method: method.toUpperCase(),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": token
        },
        credentials: "same-origin"
      });

      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const data = await response.json();

      // Update the status cell inline
      const cell = document.querySelector(`#delivery-status-${deliveryId}`);
      if (cell) {
        cell.textContent = data.status;
        cell.classList.add("fw-bold", "text-success");
        setTimeout(() => cell.classList.remove("fw-bold", "text-success"), 2000);
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: data.message || "Status updated successfully!"
      });

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again."
      });
      console.error("AJAX error:", err);
    }
  });
});
